import { render, staticRenderFns } from "./RefundNote.vue?vue&type=template&id=5a20c775&scoped=true&"
import script from "./RefundNote.vue?vue&type=script&lang=js&"
export * from "./RefundNote.vue?vue&type=script&lang=js&"
import style0 from "./RefundNote.vue?vue&type=style&index=0&id=5a20c775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20c775",
  null
  
)

export default component.exports